enum ActionType {
    REQUEST_CURRENT_USER = '[CURRENT_USER] GET CURRENT_USER',
    RECEIVE_CURRENT_USER = '[CURRENT_USER] SET CURRENT_USER',
}

export default ActionType
